import React from "react";
import {
  FiArrowLeft,
  FiCheck,
  FiCreditCard,
  FiHome,
} from "react-icons/fi";

const PaymentSuccessPage = ({
  setScreen,
  repaymentData,
    setRepaymentData,
}) => {
  const paymentType =
    repaymentData?.paymentType || "full";

  const amount =
    Number(repaymentData?.amount) || 23800;

  const remainingAmount =
    Number(repaymentData?.remainingAmount) || 0;

  const formattedAmount =
    amount.toLocaleString("en-IN");

  const formattedRemaining =
    remainingAmount.toLocaleString("en-IN");

  const isFullPayment =
    paymentType === "full";

//   const handleContinue = () => {
//     if (isFullPayment) {
//       // Full payment complete
//       setScreen("/apply-new/activeLoanHome");
//       return;
//     }

//     // Part payment ke baad next loan flow
//     setScreen("/apply-new/userInformation");
//   };
const handleContinue = () => {
  if (isFullPayment) {
    setScreen("/apply-new/activeLoanHome");
    return;
  }
   setRepaymentData((previous) => ({
    ...previous,
    paymentType: "partial",
    amount: remainingAmount,
    remainingAmount: remainingAmount,
  }));
  setScreen("/apply-new/repayment");
};
  return (
    <section className="fw-screen fw-payment-success fw-fade">

      {/* Header */}
      <header className="fw-payment-success__header">
        <button
          type="button"
          className="fw-payment-success__back"
          onClick={() =>
            setScreen("/apply-new/repayment")
          }
          aria-label="Go back"
        >
          <FiArrowLeft />
        </button>
      </header>

      {/* Success Icon */}
      <div className="fw-payment-success__icon-wrap">
        <div className="fw-payment-success__icon">
          <FiCheck />
        </div>
      </div>

      {/* Main Content */}
      <div className="fw-payment-success__content">

        <p className="fw-payment-success__eyebrow">
          PAYMENT SUCCESSFUL
        </p>

        <h1>Payment Completed</h1>

        <p className="fw-payment-success__message">
          Your repayment has been successfully
          processed.
        </p>

        {/* Payment Amount */}
        <div className="fw-payment-success__amount-card">

          <span>Amount Paid</span>

          <strong>
            ₹{formattedAmount}
          </strong>

          <small>
            {isFullPayment
              ? "Full Payment"
              : "Part Payment"}
          </small>

        </div>

        {/* Payment Details */}
        <div className="fw-payment-success__details">

          <div className="fw-payment-success__detail">
            <span>
              <FiCreditCard />
              Payment Type
            </span>

            <strong>
              {isFullPayment
                ? "Full Payment"
                : "Part Payment"}
            </strong>
          </div>

          <div className="fw-payment-success__detail">
            <span>
              Payment Status
            </span>

            <strong className="is-success">
              Successful
            </strong>
          </div>

          {!isFullPayment && (
            <div className="fw-payment-success__detail">
              <span>
                Remaining Amount
              </span>

              <strong>
                ₹{formattedRemaining}
              </strong>
            </div>
          )}

        </div>

        {/* Part Payment Message */}
        {!isFullPayment && (
          <div className="fw-payment-success__info">
            <p>
              Your part payment has been received.
              You can continue with the next loan
              process.
            </p>
          </div>
        )}

        {/* Full Payment Message */}
        {isFullPayment && (
          <div className="fw-payment-success__info">
            <p>
              Your outstanding loan amount has been
              fully paid.
            </p>
          </div>
        )}

      </div>

      {/* Footer */}
      <div className="fw-payment-success__footer">

        <button
          type="button"
          className="fw-btn fw-btn--primary fw-btn--full"
          onClick={handleContinue}
        >
          {isFullPayment ? (
            <>
              <FiHome />
              Go to Home
            </>
          ) : (
            "Continue"
          )}
        </button>

        <p className="fw-payment-success__powered">
          Payment processed securely
        </p>

      </div>

    </section>
  );
};

export default PaymentSuccessPage;